<form [formGroup]="saleTypeFormGroup"  id="step-activation-method" class="h-full">
  <div class="flex flex-1 flex-col rounded-card h-full overflow-visible pb-0">
    <div class="row">
      <div class="flex flex-col col-12">
        <h2 data-testid="sale-type-title" class="pb-2">{{ 'SALE_CREATE.SALE_TYPE' | translate }}</h2>
        <label data-testid="sale-type-select-label" class="block text-sm">{{ 'SALE_CREATE.SELECT_SALE_TYPE' | translate }}:</label>
      </div>
      <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6">
        <div class="row">
          <div class="col-12">
            <label data-testid="sale-type-serialnumber-label" class="inline-flex mr-6">
              <p-radioButton data-testid="sale-type-serialnumber" name="saleType" [value]="warrantyActivationMethod.SERIAL_NUMBER" formControlName="saleType" inputId="serial" />
              <span for="serial" class="ml-2">{{ 'SALE_CREATE.BY_SERIAL_NUMBER' | translate }}</span>
            </label>
            <label data-testid="sale-type-reference-label" class="inline-flex mr-2">
              <p-radioButton data-testid="sale-type-reference" name="saleType" [value]="warrantyActivationMethod.REFERENCE_NUMBER" formControlName="saleType" inputId="reference" />
              <span for="reference" class="ml-2">{{ 'SALE_CREATE.BY_REFERENCE_NUMBER_LIMITED_EDITION' | translate }}</span>
            </label>
          </div>
        </div>
      </div>
      <div class="field-wr flex flex-col col-12 mt-2">
        <div class="row">
          <div class="field-wr flex flex-col col-12 col-md-2">
              <button data-testid="next-step-btn" class="btn primary-btn" [disabled]="saleTypeFormGroup.invalid" (click)="onSaveStepData()">{{ 'SALE_CREATE.BTN_NEXT_STEP' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
